import { TextField } from "@mui/material";
import type { FC } from "react";

interface InfoEditProps {
  readonly value: string | number | undefined;
  readonly minRows?: number;
  readonly label?: string;
  readonly disabled?: boolean;
  readonly readonly?: boolean;
  readonly onChange: (value: string) => void;
}

export const InfoEdit: FC<InfoEditProps> = ({ value, minRows = 3, label = "Info", disabled, readonly, onChange }) => (
  <TextField
    multiline
    fullWidth
    minRows={minRows}
    value={value ?? ""}
    label={label}
    disabled={disabled}
    slotProps={{
      input: { readOnly: readonly },
    }}
    onChange={(e) => onChange(e.target.value)}
  />
);
